<template>
    <v-list-item ref="infoWindow" lines="three" class="pl-0">
        <template v-slot:prepend>
            <v-img
                v-if="offer.thumb"
                :width="isCompactMode ? '50' : '125'"
                :height="isCompactMode ? '50' : '125'"
                cover
                tile
                class="thumb me-2"
                :src="$filters.imageUrl(offer.thumb, 250)"
                :alt="offer.name"
                :lazy-src="$filters.srcHost('/placeholder.png')"
                @error="onImgError"
                @load="load"
            >
                <template v-slot:placeholder>
                    <v-row v-show="!imgError && offer.thumb" class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
            </v-img>
        </template>
        <div class="align-self-start" :class="isCompactMode ? 'small-content' : ''">
            <v-rating
                class="d-flex mr-3"
                size="x-small"
                density="compact"
                color="primary"
                readonly
                :model-value="offer.category"
            />
            <v-list-item-title :title="offer.name">
                <nuxt-link v-if="hotelPageLink" no-prefetch :to="hotelPageLink">
                    <span class="text-wrap">{{ offer.name }}</span>
                </nuxt-link>
                <span v-else class="text-wrap">
                    {{ offer.name }}
                </span>
            </v-list-item-title>
            <div class="text-subtitle-2 text--secondary font-weight-light address">
                <div v-if="offer.address" class="text-wrap">
                    <v-icon size="small" color="primary">mdi-map-marker</v-icon>
                    {{ offer.address }}
                </div>
                <div v-if="offer.distance">
                    <strong>{{ $t('distance') }}:</strong>
                    {{ kmFromCenterLabel }}
                </div>
                <div v-if="offer.district || offer.district === 'other'">
                    <strong>{{ $t('district') }}:</strong>
                    {{ offer.district }}
                </div>
            </div>
            <template v-if="minPriceRoomOffer && !minPriceRoomOffer.soldOut">
                <div
                    v-if="minPriceRoomOffer.price"
                    class="text-subtitle-1 d-flex"
                    :class="isCompactMode ? 'small-content' : ''"
                >
                    <span>
                        {{ $t('from') }}
                    </span>
                    &nbsp;
                    <price-label :price="minPriceRoomOffer.price" />
                </div>
                <offer-delta-button v-else :room="minPriceRoomOffer" />
            </template>
        </div>
    </v-list-item>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import PriceLabel from '~src/components/snippets/priceLabel.src'
    import OfferDeltaButton from '~/components/packages/search/OfferDeltaButton.vue'

    @Component({
        components: {
            PriceLabel,
            OfferDeltaButton,
        },
    })
    export class HotelMapInfoWindow extends Vue {
        @Prop() offer
        @Prop({default: true}) withLink

        imgError = false
        clientWidth = 201

        load() {
            this.setSize()
        }

        onImgError() {
            this.imgError = true
            return false
        }

        setSize() {
            this.clientWidth = this.$refs.infoWindow.$el.clientWidth
        }

        get hotelPageLink() {
            if (this.withLink) {
                return hotelsRuntimeStore.hotelPageLink(this.offer, hotelsStore.searchRequest)
            }
            return null
        }

        get minPriceRoomOffer() {
            return hotelsRuntimeStore.minPriceRoomOffer(this.offer)
        }

        get isCompactMode() {
            return this.clientWidth < 200
        }

        get kmFromCenterLabel() {
            return `${this.offer.distance} km from center`
        }
    }

    export default HotelMapInfoWindow
</script>

<style scoped>
    .small-content {
        font-size: 0.8rem !important;
    }

    .address > div {
        line-height: 1.2;
    }
</style>
